export class ReportTimeOffByUserDto {
  userId: string;
  username: string;
  firstName: string;
  lastName: string;
  days: number;
  operativeUnit: string;
}
